/**
 * @fileoverview This is the entry point for the AmplifyChat React application.
 * It finds the root DOM element and renders the main App component into it.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
console.log("INDEX.TSX: React and ReactDOM loaded!");

import App from './App';

// Find the root element in the HTML where the React app will be mounted.
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

import { Providers } from './Providers';
import { AppRouter } from './router/AppRouter';

// Create a React root and render the main App component.
// React.StrictMode is used to highlight potential problems in the app.
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <Providers>
      <AppRouter />
    </Providers>
  </React.StrictMode>
);
console.log("INDEX.TSX: root.render was called successfully!");
